export const mixinmember = {
    data() {
        return {
            curnavkv: 0,
            isload: false,
            infolist: [],
            grouplist: [],
            navsub: 0,
            options: {},
            myoption: {
                schoolid: -1,
                groupid: -1,
                projectid: -1,
                levelid: -1,
                courseid: -1,
                topicid: -1,
                kw: '',
                issch: 0,
                schstat: 0,
                tk: 0,
                schid: -1
            }
        };
    },
    components: {
        Cmember: () => import('@/components/Cmember')
    },
    methods: {
        getdata: function () {
            this.isload = true;
        },
        optionchange: function (v) {
            this.isload = false;
            this.myoption = v;
            this.$nextTick(() => {
                this.getdata();
            });

        },
        issmall: function () {
            return this.$store.getters.issmall;
        },
        isstu: function () {
            return this.$store.getters.isstu;
        },
        istea: function () {
            return this.$store.getters.istea;
        },
        groupup: function (v) {
            this.grouplist = v;
        }
    }
}

export const mixinsubpage = {
    data() {
        return {
            infolist: [],
            res: {},
            postact: '',
            isload: false
        };
    },
    props: {
        stuid: {
            type: Number,
            default: 0
        },
        navsub: {
            type: Number,
            default: 0
        },
        options: {
            type: Object,
            default: () => { }
        },
        grouplist: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        c_infolist: function () {//保持一致
            return this.infolist;
        },
        c_options: function () {
            let _options = this.$common.basic.jsonclone(this.options);
            _options.stuid = this.stuid;
            return _options;
        },
        isviewstu: function () {//是否查看具体学生
            return this.stuid > 0;
        },
        issmall: function () {
            return this.$store.getters.issmall;
        },
        isstu: function () {
            return this.$store.getters.isstu;
        },
        istea: function () {
            return this.$store.getters.istea;
        },
        isteaview: function () {
            return this.istea && !this.isviewstu;
        },
        isct: function () {
            return this.c_options.tk == 1;
        },
        istutor: function () {
            return this.c_options.tk == 2 || this.c_options.tk == 3;
        },
        islecture: function () {
            return this.c_options.tk == 4;
        },
        postjson: function () {
            return { 'postdata': { 'act': this.postact, 'data': this.c_options, 'cpage': this.res.cpage || 1 } };
        },
        wordlength: function () {
            return this.issmall ? 40 : this.isnotstu ? 12 : 16;
        }
    },
    methods: {
        getdata: function () { }

    },
    mounted() {
        this.getdata();
    }
}
